import type { IComponentController } from "angular";
import { DayTypeFunctions } from "App/Modules/Models/Models/DayTypeFunctions";
import type { IDaySchedule } from "App/Modules/Models/Models/IDaySchedule";

export default class SiteConfigurationGroupScheduleInfoComponentController implements IComponentController {
    public static $inject: string[] = [];

    public schedules: IDaySchedule[];

    public dayTypes = DayTypeFunctions.WeekDaysMap();
}
